/**
 * useTableColumns Hook
 * 根据字段配置动态生成表格列
 */

import React, { useMemo, useCallback, useState, useRef, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";
import { AddToQueueIcon } from "../../shared/AddToQueueIcon";
import { AutoTagsListCell } from "../AutoTagsListCell";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import StarIcon from "@mui/icons-material/Star";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
/** Custom Icons from SVG */
const PostAddCustomIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <g clipPath="url(#clip0_1471_56717)">
      <path
        d="M14 7.5H13.5V2C13.4995 1.60231 13.3414 1.22104 13.0602 0.939837C12.779 0.65863 12.3977 0.50045 12 0.5H5C4.97874 0.502801 4.9577 0.50701 4.937 0.5126C4.91542 0.515279 4.89406 0.519524 4.8731 0.5253C4.78813 0.544821 4.70991 0.58666 4.6465 0.6465L0.6465 4.6465C0.586507 4.71018 0.544598 4.78871 0.5251 4.874C0.519715 4.89391 0.515673 4.91415 0.513 4.9346C0.507133 4.95607 0.502789 4.97792 0.5 5V14C0.50045 14.3977 0.65863 14.779 0.939837 15.0602C1.22104 15.3414 1.60231 15.4995 2 15.5H14C14.3977 15.4995 14.779 15.3414 15.0602 15.0602C15.3414 14.779 15.4995 14.3977 15.5 14V9C15.4995 8.60231 15.3414 8.22104 15.0602 7.93984C14.779 7.65863 14.3977 7.50045 14 7.5ZM4.5 2.207V4C4.49984 4.13256 4.44711 4.25964 4.35338 4.35338C4.25964 4.44711 4.13256 4.49984 4 4.5H2.207L4.5 2.207ZM7.5783 14.4555C7.5828 14.4696 7.581 14.4861 7.5859 14.5H2C1.86744 14.4998 1.74036 14.4471 1.64662 14.3534C1.55289 14.2596 1.50016 14.1326 1.5 14V5.5H4C4.39769 5.49955 4.77896 5.34137 5.06016 5.06016C5.34137 4.77896 5.49955 4.39769 5.5 4V1.5H12C12.1326 1.50016 12.2596 1.55289 12.3534 1.64662C12.4471 1.74036 12.4998 1.86744 12.5 2V7.5H9C8.60231 7.50045 8.22104 7.65863 7.93984 7.93984C7.65863 8.22104 7.50045 8.60231 7.5 9V14C7.50208 14.155 7.5285 14.3087 7.5783 14.4555ZM14.5 14C14.4998 14.1326 14.4471 14.2596 14.3534 14.3534C14.2596 14.4471 14.1326 14.4998 14 14.5H9C8.86744 14.4998 8.74036 14.4471 8.64662 14.3534C8.55289 14.2596 8.50016 14.1326 8.5 14V9C8.50016 8.86744 8.55289 8.74036 8.64662 8.64662C8.74036 8.55289 8.86744 8.50016 9 8.5H14C14.1326 8.50016 14.2596 8.55289 14.3534 8.64662C14.4471 8.74036 14.4998 8.86744 14.5 9V14Z"
        fill="currentColor"
      />
      <mask id="path-2-inside-1_1471_56717" fill="white">
        <path d="M13 11H12V10C12 9.86739 11.9473 9.74021 11.8536 9.64645C11.7598 9.55268 11.6326 9.5 11.5 9.5C11.3674 9.5 11.2402 9.55268 11.1464 9.64645C11.0527 9.74021 11 9.86739 11 10V11H10C9.86739 11 9.74021 11.0527 9.64645 11.1464C9.55268 11.2402 9.5 11.3674 9.5 11.5C9.5 11.6326 9.55268 11.7598 9.64645 11.8536C9.74021 11.9473 9.86739 12 10 12H11V13C11 13.1326 11.0527 13.2598 11.1464 13.3536C11.2402 13.4473 11.3674 13.5 11.5 13.5C11.6326 13.5 11.7598 13.4473 11.8536 13.3536C11.9473 13.2598 12 13.1326 12 13V12H13C13.1326 12 13.2598 11.9473 13.3536 11.8536C13.4473 11.7598 13.5 11.6326 13.5 11.5C13.5 11.3674 13.4473 11.2402 13.3536 11.1464C13.2598 11.0527 13.1326 11 13 11Z" />
      </mask>
      <path
        d="M12 11H11V12H12V11ZM11 11V12H12V11H11ZM11 12H12V11H11V12ZM12 12V11H11V12H12ZM13 11V10H12V11V12H13V11ZM12 11H13V10H12H11V11H12ZM12 10H13C13 9.60218 12.842 9.22065 12.5607 8.93934L11.8536 9.64645L11.1464 10.3536C11.0527 10.2598 11 10.1326 11 10H12ZM11.8536 9.64645L12.5607 8.93934C12.2794 8.65803 11.8978 8.5 11.5 8.5V9.5V10.5C11.3674 10.5 11.2402 10.4473 11.1464 10.3536L11.8536 9.64645ZM11.5 9.5V8.5C11.1022 8.5 10.7206 8.65803 10.4393 8.93934L11.1464 9.64645L11.8536 10.3536C11.7598 10.4473 11.6326 10.5 11.5 10.5V9.5ZM11.1464 9.64645L10.4393 8.93934C10.158 9.22065 10 9.60218 10 10H11H12C12 10.1326 11.9473 10.2598 11.8536 10.3536L11.1464 9.64645ZM11 10H10V11H11H12V10H11ZM11 11V10H10V11V12H11V11ZM10 11V10C9.60218 10 9.22065 10.158 8.93934 10.4393L9.64645 11.1464L10.3536 11.8536C10.2598 11.9473 10.1326 12 10 12V11ZM9.64645 11.1464L8.93934 10.4393C8.65803 10.7206 8.5 11.1022 8.5 11.5H9.5H10.5C10.5 11.6326 10.4473 11.7598 10.3536 11.8536L9.64645 11.1464ZM9.5 11.5H8.5C8.5 11.8978 8.65803 12.2794 8.93934 12.5607L9.64645 11.8536L10.3536 11.1464C10.4473 11.2402 10.5 11.3674 10.5 11.5H9.5ZM9.64645 11.8536L8.93934 12.5607C9.22065 12.842 9.60218 13 10 13V12V11C10.1326 11 10.2598 11.0527 10.3536 11.1464L9.64645 11.8536ZM10 12V13H11V12V11H10V12ZM11 12H10V13H11H12V12H11ZM11 13H10C10 13.3978 10.158 13.7794 10.4393 14.0607L11.1464 13.3536L11.8536 12.6464C11.9473 12.7402 12 12.8674 12 13H11ZM11.1464 13.3536L10.4393 14.0607C10.7206 14.342 11.1022 14.5 11.5 14.5V13.5V12.5C11.6326 12.5 11.7598 12.5527 11.8536 12.6464L11.1464 13.3536ZM11.5 13.5V14.5C11.8978 14.5 12.2794 14.342 12.5607 14.0607L11.8536 13.3536L11.1464 12.6464C11.2402 12.5527 11.3674 12.5 11.5 12.5V13.5ZM11.8536 13.3536L12.5607 14.0607C12.842 13.7794 13 13.3978 13 13H12H11C11 12.8674 11.0527 12.7402 11.1464 12.6464L11.8536 13.3536ZM12 13H13V12H12H11V13H12ZM12 12V13H13V12V11H12V12ZM13 12V13C13.3978 13 13.7794 12.842 14.0607 12.5607L13.3536 11.8536L12.6464 11.1464C12.7402 11.0527 12.8674 11 13 11V12ZM13.3536 11.8536L14.0607 12.5607C14.342 12.2794 14.5 11.8978 14.5 11.5H13.5H12.5C12.5 11.3674 12.5527 11.2402 12.6464 11.1464L13.3536 11.8536ZM13.5 11.5H14.5C14.5 11.1022 14.342 10.7206 14.0607 10.4393L13.3536 11.1464L12.6464 11.8536C12.5527 11.7598 12.5 11.6326 12.5 11.5H13.5ZM13.3536 11.1464L14.0607 10.4393C13.7794 10.158 13.3978 10 13 10V11V12C12.8674 12 12.7402 11.9473 12.6464 11.8536L13.3536 11.1464Z"
        fill="currentColor"
        mask="url(#path-2-inside-1_1471_56717)"
      />
    </g>
    <defs>
      <clipPath id="clip0_1471_56717">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
const HubCustomIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10Z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4C14 5.10457 13.1046 6 12 6ZM12 6C12 9.31371 9.31371 12 6 12"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 10L4 2"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

import {
  StarBorderCustomIcon,
  regulationFavoriteIconButtonSx,
  regulationFavoriteIconSx,
} from "../regulationFavoriteIcons";

import type {
  GridColDef,
  GridRenderCellParams,
  GridSortModel,
} from "@mui/x-data-grid-premium";
import {
  gridFilterOperatorsFromFieldConfig,
  isFieldConfigColumnFilterable,
} from "../utils/gridFilterOperatorsFromFieldConfig";
import {
  addRegulationFavorite,
  removeRegulationFavorite,
  formatCommaSeparatedListForDisplay,
  getListCellSortOrderForField,
  isDynamicAutoTagsField,
  isRegulationCategoriesFieldName,
  visibleProductTypes,
  type FieldConfig,
  type RegulationRow,
  type ImpactedConceptItem,
} from "../../../services/regulationsService";
import { autoTagEmptyDisplay } from "../../../services/regulationAutoTags";
import {
  AutoTagDisplayLabel,
  plainAutoTagHeaderName,
  stripAutoTagMarkFromDisplayName,
} from "../../shared/AutoTagDisplayLabel";
import { buildRegulationDetailPath, buildRegulationDetailHref } from "../../../utils/externalNavigation";
import { REGULATION_DETAIL_LINK_COLOR } from "../../../branding/constants/defaultBranding";
import { useSnackbar } from "../../../contexts/SnackbarContext";
import { useHasPrivilege } from "../../../hooks/useHasPrivilege";
import { useAppStore, selectAssessmentSidebarIds } from "../../../stores";
import { RunAiAssessmentMenuButton } from "../RunAiAssessmentMenuButton";
import {
  fieldNameToRowKey,
  getListTableColumnHeaderName,
  pickListTableFieldsInOrder,
} from "./listTableColumnConfig";

export {
  buildDefaultListColumnVisibilityModel,
  buildGridOrderedRowKeys,
  filterListTableFieldsForColumnFilterPanel,
  getListTableColumnHeaderName,
  LIST_TABLE_COLUMN_ORDER,
  LIST_TABLE_COLUMN_VISIBILITY_LOCKED_FIELDS,
} from "./listTableColumnConfig";

/** Minimum width for Regulation ID column — link + 3 hover icons; narrower causes overlap with adjacent columns */
const REGULATION_ID_COLUMN_MIN_WIDTH = 200;

/** Row context for opening Start Manual Assessment from the landing table. */
export type StartManualAssessmentFromTablePayload = Readonly<{
  regulationId: string;
  regulationVersion: string;
  regulationTitle: string;
}>;

// RegulationIdCell Component - simplified to remove hover actions (moved to Actions column)
const RegulationIdCell: React.FC<{
  regulationId: string;
  row: RegulationRow;
  navigate: ReturnType<typeof useNavigate>;
}> = ({ regulationId, row, navigate }) => {
  const detailsPath = buildRegulationDetailPath(regulationId);
  const detailsHref = buildRegulationDetailHref(regulationId);

  const handleViewDetails = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(detailsPath);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        py: 1,
        width: "100%",
        height: "100%",
        lineHeight: 1.2,
      }}
    >
      {/* First Row: ID */}
      <Link
        href={detailsHref}
        underline="hover"
        sx={{
          color: REGULATION_DETAIL_LINK_COLOR,
          fontWeight: 500,
          cursor: "pointer",
          fontSize: "14px",
          "&:visited": { color: REGULATION_DETAIL_LINK_COLOR },
          "&:hover": { color: REGULATION_DETAIL_LINK_COLOR },
        }}
        onClick={handleViewDetails}
      >
        {regulationId}
      </Link>

      {/* Second Row: Version and NEW Tag */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            height: "16px",
            px: 0.75,
            fontSize: "0.65rem",
            fontWeight: 600,
            color: "grey.600",
            backgroundColor: "grey.100",
            border: "1px solid",
            borderColor: "grey.300",
            borderRadius: 1,
          }}
        >
          v{row.version}
        </Box>
        {row.isNew && (
          <Chip
            label="NEW"
            size="small"
            sx={{
              height: "16px",
              fontSize: "0.65rem",
              fontWeight: "bold",
              backgroundColor: "success.main",
              color: "white",
              "& .MuiChip-label": {
                px: 0.75,
                py: 0,
              },
            }}
          />
        )}
      </Box>
    </Box>
  );
};

const centeredCellRootSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  minWidth: 0,
  minHeight: 0,
  boxSizing: "border-box" as const,
};

const plainTextCellRootSx = {
  display: "flex",
  alignItems: "center",
  height: "100%",
  width: "100%",
  minWidth: 0,
  minHeight: 0,
  boxSizing: "border-box" as const,
};

/** Plain text with ellipsis; optional centered layout (Tags column). */
const PlainTextEllipsisCell: React.FC<{
  value?: string;
  centered?: boolean;
  /** When value is empty, show this instead of "-". */
  emptyPlaceholder?: string;
}> = ({ value, centered = false, emptyPlaceholder = "-" }) => {
  const text = typeof value === "string" ? value.trim() : "";
  const rootSx = centered ? centeredCellRootSx : plainTextCellRootSx;
  if (!text) {
    const isDash = emptyPlaceholder === "-";
    return (
      <Box sx={rootSx}>
        <Typography
          variant="body2"
          color={isDash ? "text.secondary" : "inherit"}
          noWrap={!isDash}
          sx={{
            lineHeight: 1.4,
            textAlign: centered ? "center" : "left",
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: isDash ? undefined : "ellipsis",
          }}
        >
          {emptyPlaceholder}
        </Typography>
      </Box>
    );
  }
  return (
    <Box sx={rootSx}>
      <Typography
        variant="body2"
        noWrap
        title={text}
        sx={{
          width: "100%",
          maxWidth: "100%",
          lineHeight: 1.4,
          textAlign: centered ? "center" : "left",
          overflow: "hidden",
          textOverflow: "ellipsis",
          cursor: "default",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

/** Comma-separated tags/categories with ellipsis and full-value tooltip */
const TagsCell: React.FC<{ value?: string }> = ({ value }) => (
  <PlainTextEllipsisCell value={value} />
);

const impactedConceptChipSx = {
  height: 24,
  maxWidth: "100%",
  bgcolor: "#f0f2f5",
  color: "text.primary",
  fontSize: "0.75rem",
  fontWeight: 500,
  borderRadius: "12px",
  border: "none",
  "& .MuiChip-label": {
    px: 1.25,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

const impactedConceptsCellRootSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  height: "100%",
  width: "100%",
  minHeight: 0,
  boxSizing: "border-box" as const,
};

const NO_IMPACT_DISPLAY_LABEL = "No Impact";

/** Plain text for sentinel "No impact" from API — no chip styling */
function isNoImpactConceptLabel(name: string): boolean {
  return name.trim().toLowerCase() === "no impact";
}

function formatImpactedConceptDisplayName(name: string): string {
  return isNoImpactConceptLabel(name) ? NO_IMPACT_DISPLAY_LABEL : name;
}

const noImpactTypographySx = {
  lineHeight: 1.2,
  textAlign: "left" as const,
  px: 0.5,
  wordBreak: "break-word" as const,
};

const IMPACTED_CONCEPTS_TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      bgcolor: "rgba(50, 50, 50, 0.95)",
      maxWidth: 600,
      "& .MuiTooltip-arrow": { color: "rgba(50, 50, 50, 0.95)" },
    },
  },
} as const;

const ImpactedConceptsTooltipContent: React.FC<{ names: string[] }> = ({
  names,
}) => (
  <Box
    sx={{
      maxWidth: 560,
      maxHeight: 280,
      overflow: "auto",
      fontSize: "13px",
      lineHeight: 1.6,
      color: "#fff",
      whiteSpace: "normal",
      wordBreak: "break-word",
      py: 0.25,
    }}
  >
    {names.map(formatImpactedConceptDisplayName).join(", ")}
  </Box>
);

/** First concept as a pill + optional "+N"; tooltip lists all concept names */
const ImpactedConceptsCell: React.FC<{
  concepts?: ImpactedConceptItem[];
}> = ({ concepts }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const rawNames =
    concepts
      ?.map((c) => {
        const n = c?.name;
        if (typeof n === "string") return n.trim();
        return "";
      })
      .filter((n) => n.length > 0) ?? [];

  const allNoImpact =
    rawNames.length > 0 && rawNames.every((n) => isNoImpactConceptLabel(n));
  const names = allNoImpact ? [rawNames[0]] : rawNames;

  const [first, ...rest] = names;
  const overflowCount = rest.length;

  useLayoutEffect(() => {
    const el = contentRef.current;
    if (!el) {
      setIsOverflow(false);
      return;
    }
    const measure = () => {
      setIsOverflow(el.scrollWidth > el.clientWidth + 1);
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [first, overflowCount, names.length]);

  if (names.length === 0) {
    return (
      <Box sx={impactedConceptsCellRootSx}>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.2 }}>
          -
        </Typography>
      </Box>
    );
  }

  const showTooltip = names.length > 1 || isOverflow;

  const cellBody = (
    <Box
      ref={contentRef}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 0.5,
        flexWrap: "nowrap",
        width: "100%",
        minWidth: 0,
        overflow: "hidden",
      }}
    >
      {isNoImpactConceptLabel(first) ? (
        <Typography
          variant="body2"
          color="text.secondary"
          noWrap
          sx={{ ...noImpactTypographySx, minWidth: 0, flex: "1 1 auto" }}
        >
          {formatImpactedConceptDisplayName(first)}
        </Typography>
      ) : (
        <Chip label={first} size="small" sx={{ ...impactedConceptChipSx, flexShrink: 1 }} />
      )}
      {overflowCount > 0 ? (
        <Chip
          label={`+${overflowCount}`}
          size="small"
          sx={{ ...impactedConceptChipSx, flexShrink: 0 }}
        />
      ) : null}
    </Box>
  );

  return (
    <Box sx={impactedConceptsCellRootSx}>
      <Tooltip
        title={<ImpactedConceptsTooltipContent names={names} />}
        arrow
        enterDelay={300}
        disableHoverListener={!showTooltip}
        slotProps={IMPACTED_CONCEPTS_TOOLTIP_SLOT_PROPS}
      >
        <Box
          sx={{
            width: "100%",
            minWidth: 0,
            cursor: showTooltip ? "default" : undefined,
          }}
        >
          {cellBody}
        </Box>
      </Tooltip>
    </Box>
  );
};

/** Action icon + tooltip — same pattern as Assessment Center `ImpactAssessmentActionIconButton`. */
const RegulationTableActionIconButton: React.FC<{
  title: string;
  ariaLabel: string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  children: React.ReactNode;
}> = ({ title, ariaLabel, disabled = false, onClick, children }) => (
  <Tooltip title={disabled ? "" : title}>
    <IconButton
      size="small"
      aria-label={ariaLabel}
      disabled={disabled}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={onClick}
      sx={regulationFavoriteIconButtonSx}
    >
      {children}
    </IconButton>
  </Tooltip>
);

const actionsCellRootSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 0.5,
  width: "100%",
  height: "100%",
} as const;

// ActionsCell Component - dedicated actions column
const ActionsCell: React.FC<{
  row: RegulationRow;
  onOpenStartManualAssessment?: (
    regulationId: string,
    version: string,
    title: string,
  ) => void;
  maxRegulationsPerBatch: number;
  onFavoriteChange?: (regulationId: string, isFavorite: boolean) => void;
  onRowCompanyScopeImpact?: (regulationId: string) => void;
  onRowCustomScopeImpact?: (regulationId: string) => void;
  companyScopeStarting?: boolean;
}> = ({
  row,
  onOpenStartManualAssessment,
  maxRegulationsPerBatch,
  onFavoriteChange,
  onRowCompanyScopeImpact,
  onRowCustomScopeImpact,
  companyScopeStarting = false,
}) => {
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();
  const canRunSystemImpact = useHasPrivilege(
    "gri.assessment.impact.system.execute",
  );
  /** Same gate as Bulk Action → Add to Assessment Queue. */
  const canShowAddToAssessmentQueue = useHasPrivilege(
    [
      "gri.assessment.impact.execute",
      "gri.assessment.impact.system.execute",
    ],
    "any",
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [favoriteSubmitting, setFavoriteSubmitting] = useState(false);
  const open = Boolean(anchorEl);
  const isFavorite = Boolean(row.isFavorite);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleMenuClose = useCallback(
    (_event: object, _reason: "backdropClick" | "escapeKeyDown") => {
      setAnchorEl(null);
    },
    [],
  );

  const handleView = (e: React.MouseEvent) => {
    e.stopPropagation();
    closeMenu();
    navigate(buildRegulationDetailPath(row.id));
  };

  const assessmentSidebarIds = useAppStore(selectAssessmentSidebarIds);
  const addAssessmentSidebarId = useAppStore(
    (state) => state.addAssessmentSidebarId,
  );

  const isAlreadyAdded = assessmentSidebarIds.includes(row.id);
  const isAtLimit = assessmentSidebarIds.length >= maxRegulationsPerBatch;
  const canAddToAssessment = !isAlreadyAdded && !isAtLimit;

  let addToAssessmentTooltip = "Add to Assessment Queue";
  if (isAlreadyAdded) addToAssessmentTooltip = "Already added";
  else if (isAtLimit) {
    addToAssessmentTooltip = `Maximum ${maxRegulationsPerBatch} regulations`;
  }

  const handleAddToAssessment = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    addAssessmentSidebarId(row.id, row.version, maxRegulationsPerBatch);
  };

  const handleToggleFavorite = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (favoriteSubmitting || !onFavoriteChange) return;
    const nextFavorite = !isFavorite;
    setFavoriteSubmitting(true);
    try {
      if (nextFavorite) {
        await addRegulationFavorite(row.id);
      } else {
        await removeRegulationFavorite(row.id);
      }
      onFavoriteChange(row.id, nextFavorite);
      showMessage(
        nextFavorite ? "Added to favorites" : "Removed from favorites",
        "success",
      );
    } catch (err) {
      showMessage(
        err instanceof Error ? err.message : "Failed to update favorite",
        "error",
      );
    } finally {
      setFavoriteSubmitting(false);
    }
  };

  const iconButtonStyle = regulationFavoriteIconButtonSx;

  const iconStyle = regulationFavoriteIconSx;

  return (
    <Box sx={actionsCellRootSx}>
      {canShowAddToAssessmentQueue ? (
        <RegulationTableActionIconButton
          title={addToAssessmentTooltip}
          ariaLabel="add to assessment queue"
          disabled={!canAddToAssessment}
          onClick={handleAddToAssessment}
        >
          <PostAddCustomIcon sx={iconStyle} />
        </RegulationTableActionIconButton>
      ) : null}
      <RunAiAssessmentMenuButton
        variant="iconOnly"
        companyScopeStarting={companyScopeStarting}
        onCompanyScopeImpact={
          canRunSystemImpact && onRowCompanyScopeImpact
            ? () => onRowCompanyScopeImpact(row.id)
            : undefined
        }
        onCustomScopeImpact={
          onRowCustomScopeImpact
            ? () => onRowCustomScopeImpact(row.id)
            : undefined
        }
      />
      {onOpenStartManualAssessment ? (
        <RegulationTableActionIconButton
          title="Start Manual Assessment"
          ariaLabel="start manual assessment"
          onClick={(e) => {
            e.stopPropagation();
            onOpenStartManualAssessment(row.id, row.version, row.title ?? "");
          }}
        >
          <HubCustomIcon sx={iconStyle} />
        </RegulationTableActionIconButton>
      ) : null}
      <RegulationTableActionIconButton
        title={isFavorite ? "Remove from favorites" : "Add to favorites"}
        ariaLabel={isFavorite ? "remove from favorites" : "add to favorites"}
        disabled={favoriteSubmitting || !onFavoriteChange}
        onClick={handleToggleFavorite}
      >
        {isFavorite ? (
          <StarIcon
            sx={{
              ...iconStyle,
              color: "#f59e0b",
            }}
          />
        ) : (
          <StarBorderCustomIcon sx={iconStyle} />
        )}
      </RegulationTableActionIconButton>
      <IconButton
        size="small"
        sx={iconButtonStyle}
        onClick={handleClick}
        aria-label="more actions"
      >
        <MoreVertIcon sx={iconStyle} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        PaperProps={{
          sx: {
            boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
            mt: 0.5,
            minWidth: 120,
            '& .MuiMenuItem-root': {
              fontSize: '13px',
              py: 0.5,
              px: 1.5,
            },
          },
        }}
      >
        <MenuItem onClick={handleView}>
          <ListItemIcon sx={{ minWidth: '28px !important' }}>
            <VisibilityOutlinedIcon sx={{ fontSize: '1.1rem', color: '#595959' }} />
          </ListItemIcon>
          <ListItemText primary="View" />
        </MenuItem>
      </Menu>
    </Box>
  );
};

export const useTableColumns = (
  fieldsConfig: FieldConfig[],
  maxRegulationsPerBatch: number = 5,
  onRegulationFavoriteChange?: (
    regulationId: string,
    isFavorite: boolean,
  ) => void,
  onOpenStartManualAssessment?: (
    payload: StartManualAssessmentFromTablePayload,
  ) => void,
  onRowCompanyScopeImpact?: (regulationId: string) => void,
  onRowCustomScopeImpact?: (regulationId: string) => void,
  companyScopeLoadingRegulationIds: readonly string[] = [],
  sortModel: GridSortModel = [],
) => {
  const companyScopeLoadingIdSet = useMemo(
    () => new Set(companyScopeLoadingRegulationIds),
    [companyScopeLoadingRegulationIds],
  );
  const navigate = useNavigate();

  const notifyStartManualAssessment = useCallback(
    (regulationId: string, regulationVersion: string, regulationTitle: string) => {
      onOpenStartManualAssessment?.({
        regulationId,
        regulationVersion,
        regulationTitle,
      });
    },
    [onOpenStartManualAssessment],
  );

  // Create render function for regulation_id link with version and NEW tag
  const createRegulationIdRenderer = useCallback(
    () => (params: GridRenderCellParams<RegulationRow>) => {
      const regulationId = params.value;
      const row = params.row;
      return (
        <RegulationIdCell
          regulationId={regulationId}
          row={row}
          navigate={navigate}
        />
      );
    },
    [navigate],
  );

  // Create render function for the Actions column
  const createActionsRenderer = useCallback(
    () => (params: GridRenderCellParams<RegulationRow>) => {
      return (
        <ActionsCell
          row={params.row}
          onOpenStartManualAssessment={
            onOpenStartManualAssessment
              ? notifyStartManualAssessment
              : undefined
          }
          maxRegulationsPerBatch={maxRegulationsPerBatch}
          onFavoriteChange={onRegulationFavoriteChange}
          onRowCompanyScopeImpact={onRowCompanyScopeImpact}
          onRowCustomScopeImpact={onRowCustomScopeImpact}
          companyScopeStarting={companyScopeLoadingIdSet.has(params.row.id)}
        />
      );
    },
    [
      onOpenStartManualAssessment,
      notifyStartManualAssessment,
      maxRegulationsPerBatch,
      onRegulationFavoriteChange,
      onRowCompanyScopeImpact,
      onRowCustomScopeImpact,
      companyScopeLoadingIdSet,
    ],
  );

  const listColumnFilterProps = (field: FieldConfig) => ({
    filterable: isFieldConfigColumnFilterable(field),
    filterOperators: gridFilterOperatorsFromFieldConfig(field),
  });

  // Generate columns dynamically from fields configuration
  const columns = useMemo<GridColDef<RegulationRow>[]>(() => {
    if (fieldsConfig.length === 0) {
      // Return empty columns if config not loaded yet
      return [];
    }

    const dynamicColumns: GridColDef<RegulationRow>[] = [];

    // Fields from GET ?page_type=list are already scoped; keep pages:"list" when
    // present, but still include dynamic auto-tag fields / empty pages.
    const listPageFields = fieldsConfig.filter(
      (field) =>
        field.pages.length === 0 ||
        field.pages.includes("list") ||
        isDynamicAutoTagsField(field),
    );

    const displayFields = pickListTableFieldsInOrder(listPageFields);

    displayFields.forEach((field) => {
      const rowKey = fieldNameToRowKey(field.field_name);

      // Special handling for regulation_id - render as link with version and actions
      if (field.field_name === "regulation_id") {
        dynamicColumns.push({
          field: rowKey,
          headerName: getListTableColumnHeaderName(field, rowKey),
          width: 260,
          minWidth: REGULATION_ID_COLUMN_MIN_WIDTH,
          sortable: field.sortable,
          ...listColumnFilterProps(field),
          renderCell: createRegulationIdRenderer(),
          cellClassName: "regulation-id-cell",
          hideable: false,
        });
      } else if (
        field.field_name === "categories" ||
        field.field_name === "tags"
      ) {
        dynamicColumns.push({
          field: rowKey,
          headerName: "Tags",
          minWidth: 160,
          width: 180,
          sortable: field.sortable,
          ...listColumnFilterProps(field),
          editable: false,
          align: "left",
          headerAlign: "left",
          cellClassName: "tags-cell",
          renderCell: (params: GridRenderCellParams<RegulationRow>) => (
            <TagsCell
              value={formatCommaSeparatedListForDisplay(
                params.row.tags,
                getListCellSortOrderForField(sortModel, "tags"),
              )}
            />
          ),
        });
      } else if (field.field_name === "auto_tags") {
        dynamicColumns.push({
          field: rowKey,
          headerName: "Auto Tags",
          minWidth: 160,
          width: 180,
          sortable: field.sortable,
          ...listColumnFilterProps(field),
          editable: false,
          align: "left",
          headerAlign: "left",
          cellClassName: "auto-tags-cell",
          renderCell: (params: GridRenderCellParams<RegulationRow>) => (
            <AutoTagsListCell
              value={params.row.autoTags}
              groups={params.row.autoTagGroups}
              fieldPresent={params.row.autoTagsFieldPresent}
            />
          ),
        });
      } else if (
        field.field_name === "synopsis_withouthtml" ||
        field.field_name === "synopsis"
      ) {
        dynamicColumns.push({
          field: rowKey,
          headerName: getListTableColumnHeaderName(field, rowKey),
          minWidth: 200,
          flex: 1,
          sortable: field.sortable,
          ...listColumnFilterProps(field),
          editable: false,
          cellClassName: "synopsis-cell",
          renderCell: (params: GridRenderCellParams<RegulationRow>) => (
            <PlainTextEllipsisCell value={params.row.synopsis} />
          ),
        });
      } else if (field.field_name === "impacted_concepts") {
        dynamicColumns.push({
          field: rowKey,
          headerName: getListTableColumnHeaderName(field, rowKey),
          minWidth: 240,
          flex: 1,
          sortable: field.sortable,
          ...listColumnFilterProps(field),
          editable: false,
          align: "left",
          headerAlign: "left",
          cellClassName: "impacted-concepts-cell",
          renderCell: (params: GridRenderCellParams<RegulationRow>) => (
            <ImpactedConceptsCell concepts={params.row.impactedConcepts} />
          ),
        });
      } else {
        // Regular field
        const baseHeaderName = getListTableColumnHeaderName(field, rowKey);
        const isDynamicAutoTagColumn =
          isDynamicAutoTagsField(field) && field.field_name !== "auto_tags";
        const columnDef: GridColDef<RegulationRow> = {
          field: rowKey,
          // Manage Columns / a11y still show a TAG mark (unicode); header UI uses <sup>.
          headerName: isDynamicAutoTagColumn
            ? plainAutoTagHeaderName(baseHeaderName)
            : baseHeaderName,
          sortable: field.sortable,
          ...listColumnFilterProps(field),
          editable: false, // Set to false for now, can be made dynamic if needed
          ...(field.field_name === "title" ? { hideable: false } : {}),
          ...(isDynamicAutoTagColumn
            ? {
                renderHeader: () => (
                  <AutoTagDisplayLabel
                    label={stripAutoTagMarkFromDisplayName(baseHeaderName)}
                  />
                ),
              }
            : {}),
        };

        // Set width based on field type or name
        if (
          field.field_name === "title" ||
          field.field_name === "related_regulations" ||
          field.field_name === "related_items"
        ) {
          columnDef.minWidth = 200;
          columnDef.flex = 1;
        } else if (field.field_name === "markets") {
          columnDef.minWidth = 160;
          columnDef.flex = 1;
          columnDef.renderCell = (params: GridRenderCellParams<RegulationRow>) => (
            <PlainTextEllipsisCell
              value={formatCommaSeparatedListForDisplay(
                params.row.markets,
                getListCellSortOrderForField(sortModel, "markets"),
              )}
            />
          );
        } else if (field.field_name === "product_types") {
          columnDef.minWidth = 160;
          columnDef.flex = 1;
          columnDef.renderCell = (params: GridRenderCellParams<RegulationRow>) => (
            <PlainTextEllipsisCell
              value={formatCommaSeparatedListForDisplay(
                params.row.productTypes,
                getListCellSortOrderForField(sortModel, "productTypes"),
              )}
            />
          );
        } else if (
          field.field_name.includes("date") ||
          field.field_type === "date"
        ) {
          columnDef.width = 170;
        } else {
          columnDef.width = 140;
        }

        if (!columnDef.renderCell) {
          columnDef.renderCell = (params: GridRenderCellParams<RegulationRow>) => {
            const rowRecord = params.row as Record<string, unknown>;
            const raw = rowRecord[rowKey] ?? params.value;
            const text =
              raw == null || raw === ""
                ? ""
                : typeof raw === "string"
                  ? raw
                  : String(raw);
            return (
              <PlainTextEllipsisCell
                value={text}
                emptyPlaceholder={
                  isDynamicAutoTagColumn
                    ? autoTagEmptyDisplay(
                        // API omitted auto_tags → NA; returned empty → "-"
                        Boolean(params.row.autoTagsFieldPresent),
                      )
                    : "-"
                }
              />
            );
          };
        }

        dynamicColumns.push(columnDef);
      }
    });

    // Add Actions column at the far right
    dynamicColumns.push({
      field: "actions",
      headerName: "Actions",
      width: 200,
      sortable: false,
      filterable: false,
      disableReorder: true,
      resizable: false,
      pinned: "right",
      hideable: false,
      align: "center",
      headerAlign: "center",
      renderCell: createActionsRenderer(),
    } as GridColDef<RegulationRow>);

    return dynamicColumns;
  }, [fieldsConfig, createRegulationIdRenderer, createActionsRenderer, sortModel]);

  const orderedRowKeys = useMemo(
    () =>
      columns
        .map((col) => col.field)
        .filter(
          (field): field is string =>
            typeof field === "string" &&
            field !== "actions" &&
            field !== "__check__",
        ),
    [columns],
  );

  return {
    columns,
    orderedRowKeys,
  };
};
